// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ih-3";
export var downloadButton = "_ih-4";
export var fileContainer = "_ih-9 _ih-7";
export var fileContainerBase = "_ih-7";
export var fileContainerFixedHeight = "_ih-8 _ih-7";
export var fileInfo = "_ih-5";
export var fileInfoWidthRestricted = "_ih-6";
export var fileType = "_ih-1";
export var fileTypeName = "_ih-2";
export var image = "_ih-0";
export var link = "_ih-b";
export var overflowEllipsis = "_ih-a";